export default {
    methods: {
        /**
         * @param {string} text
         */
        nl2array (text) {
            if (typeof text !== 'string') return

            const regexNewLine = /([\r\n]?)(\r\n|\n\r|\r|\n)/g

            return text.split(regexNewLine).filter(function (element) {
                const trimmedElement = element.trim()
                return trimmedElement !== null && trimmedElement !== '' && !trimmedElement.match(regexNewLine)
            })
        }
    }
}
